import { Point } from "../area/Point";
import { ScaleAdjustmentValue } from "../getScaleFactor";
import { getCanvasLine, getCanvasRect } from "../konva/getCanvas";
import Konva from "konva";
import { Modul } from '../panel/Modul';

export default class RoofRange {
      pTopLeft: Point;
      pTopRight: Point;
      pBottomLeft: Point;
      pBottomRight: Point;
      color: string;
      roofRangeLable: string = "";

      constructor(color: string) {
            this.color = color;
      }

      draw(layer: Konva.Layer): void {

            var points: number[] = this.getPoints([this.pTopLeft, this.pTopRight, this.pBottomRight, this.pBottomLeft]);

            var shape = getCanvasLine({
                  points: points,
                  fill: this.color,
                  closed: true,
                  name: 'boundaryArea',
                  opacity: 1
            });
            layer.add(shape);
            shape.draw();
      }

      getPoints(points: Point[]): number[] {
            var result: number[] = [];
            points.forEach((item) => {
                  result.push(ScaleAdjustmentValue.getScaleAdjust(item.x), ScaleAdjustmentValue.getScaleAdjust(item.y));
            })
            return result;
      }

      setLabel(lable: string) {
            this.roofRangeLable = lable;
      }
      public isModuleInRange(oMod: any, obj?: any): boolean {
            // removing 100cm gap due to scale drawn
            const x = oMod.x - 100;
            const y = oMod.y - 100;
            //top-left
            if (this.isInRange(x, y)) {
                  return true;
            }
            //top-right
            if (this.isInRange(x + oMod.width, y)) {
                  return true;
            }
            //bottom-left
            if (this.isInRange(x, y + oMod.height)) {
                  return true;
            }
            //bottom-right
            if (this.isInRange(x + oMod.width, y + oMod.height)) {
                  return true;
            }
            //bereich innerhalb modul
            if (this.pTopLeft.x >= x && this.pTopLeft.x <= x + oMod.width && this.pTopLeft.y >= y && this.pTopLeft.y <= y + oMod.height) {
                  return true;
            }

            return false;
      }

      /*
          Checkt ob ein Punkt innerhalb dieses 4-Ecks liegt
          Note: Obere und untere Seite müssen waagerecht parallel zueinander liegen, linke und rechte Seite dürfen beliebig schräg
          aber nicht waagerecht sein 
    */
      public isInRange(nX: number, nY: number): boolean {
            var nTop: number;
            var nBottom: number;
            var nLeft: number;
            var nRight: number;
            var nWidth: number;
            var nHeight: number;
            var nX2: number;
            var nY2: number;
            //Früher ausscheiden
            nTop = this.pTopLeft.y > this.pTopRight.y ? this.pTopRight.y : this.pTopLeft.y;
            if (nY < nTop) {
                  return false;
            }
            nBottom = this.pBottomLeft.y < this.pBottomRight.y ? this.pBottomRight.y : this.pBottomLeft.y;
            if (nY > nBottom) {
                  return false;
            }
            nLeft = this.pTopLeft.x > this.pBottomLeft.x ? this.pBottomLeft.x : this.pTopLeft.x;
            if (nX < nLeft) {
                  return false;
            }
            nRight = this.pTopRight.x < this.pBottomRight.x ? this.pBottomRight.x : this.pTopRight.x;
            if (nX > nRight) {
                  return false;
            }
            //X-Achse-Check
            //Left
            nHeight = this.pBottomLeft.y - this.pTopLeft.y;
            if (this.pTopLeft.x > this.pBottomLeft.x) {
                  nY2 = this.pBottomLeft.y - nY;
                  nX2 = this.pBottomLeft.x + Math.abs((this.pTopLeft.x - this.pBottomLeft.x) / nHeight) * nY2;
            } else if (this.pTopLeft.x < this.pBottomLeft.x) {
                  nY2 = nY - this.pTopLeft.y;
                  nX2 = this.pTopLeft.x + Math.abs((this.pTopLeft.x - this.pBottomLeft.x) / nHeight) * nY2;
            } else {
                  nX2 = this.pTopLeft.x;
            }
            if (nX < nX2) {
                  return false;
            }
            //Right
            nHeight = this.pBottomRight.y - this.pTopRight.y;
            if (this.pTopRight.x > this.pBottomRight.x) {
                  nY2 = this.pBottomRight.y - nY;
                  nX2 = this.pBottomRight.x + Math.abs((this.pTopRight.x - this.pBottomRight.x) / nHeight) * nY2;
            } else if (this.pTopRight.x < this.pBottomRight.x) {
                  nY2 = nY - this.pTopRight.y;
                  nX2 = this.pTopRight.x + Math.abs((this.pTopRight.x - this.pBottomRight.x) / nHeight) * nY2;
            } else {
                  nX2 = this.pTopRight.x;
            }
            if (nX > nX2) {
                  return false;
            }
            return true;
      }

}